import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyFailed: (assetCount: number) => string;
    copyDenied: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            copyFailed: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (assetCount: number): string => __intl__.intl().formatMessage({ id: "useBulkCopyAssets.copyFailed?c=12yprxk3pp6qn", defaultMessage: "Failed to copy {assetCount} items" }, { assetCount: assetCount }));
                },
                enumerable: true,
                configurable: true
            },
            copyDenied: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useBulkCopyAssets.copyDenied?c=18fdta1jn611e", defaultMessage: "You don''t have permission to copy these items." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
